<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/units/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th width="10px">&nbsp;</th>
                <th>Name</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <draggable v-model="units" tag="tbody" handle=".handle"
              @end="updateOrder"
            >
              <tr v-for="unit in units" :key="unit.id">
                <td class="handle"><i class="fas fa-arrows-alt-v"></i></td>
                <td v-text="unit.name"></td>
                <td class="text-right">
                  <div class="td-actions">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                       @click="editUnit(unit)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                       @click="deleteUnit(unit)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: { draggable },
  data () {
    return {
      units: []
    }
  },
  methods: {
    editUnit (unit) {
      this.$router.push(`/units/${unit.id}/edit`)
    },
    async deleteUnit (unit) {
      if (confirm(`Einheit ${unit.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/units/${unit.id}`).then(({ data }) => {
          this.$notify({
            message: `Einheit ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.units.findIndex(({ id }) => data.id === id)
          this.units.splice(index, 1)
        })
      }
    },
    async updateOrder () {
      await this.initCsrf()

      const units = this.units.reduce((units, unit, idx) => ({ ...units, [unit.id]: idx }), {})
      this.$http.put(`/units`, { units })
    }
  },
  created () {
    this.$http.get('/units').then(({ data }) => { this.units = data })
  }
}
</script>
